import React from "react";
import "./ItemSkeleton.css";

/**
 * Skeleton loader for ItemButton components
 * Shows animated placeholder while data loads
 * Matches the horizontal layout of ItemButton (icon | text | arrow)
 */
const ItemSkeleton = ({ count = 3 }) => {
  return (
    <>
      {Array.from({ length: count }).map((_, index) => (
        <div key={index} className="item-skeleton">
          <div className="item-skeleton-content">
            <div className="item-skeleton-icon"></div>
            <div className="item-skeleton-text"></div>
            <div className="item-skeleton-arrow"></div>
          </div>
        </div>
      ))}
    </>
  );
};

export default ItemSkeleton;
